import { render, staticRenderFns } from "./UserDetailsContactInformationRevision.vue?vue&type=template&id=6a4919cd&scoped=true&"
import script from "./UserDetailsContactInformationRevision.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsContactInformationRevision.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailsContactInformationRevision.vue?vue&type=style&index=0&id=6a4919cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4919cd",
  null
  
)

export default component.exports